"use client";

import { useState } from "react";

import { TravelAlert as AlertComponent } from "@jetblue/kit/travel-alert";
import type { TravelAlertProperties } from "../../../dialogs/nav/travel-alerts";

export const TravelAlert = ({
  content,
  isActive,
  showCloseButton,
  theme,
}: TravelAlertProperties) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isActive || !isOpen) {
    return null;
  }

  return (
    <AlertComponent
      hasWhiteText={theme === "dark"}
      onCloseClick={() => {
        setIsOpen(false);
      }}
      showCloseButton={showCloseButton}
    >
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </AlertComponent>
  );
};
